export const INVOICE_TYPE_OPTIONS = [
  {
    value: 'STANDARD',
    label: 'Standard invoice',
    hint: 'GST is added at 10% on top of line prices (tax invoice).',
  },
  {
    value: 'GST_INCLUDED',
    label: 'GST included',
    hint: 'Line prices already include GST. The document shows GST included.',
  },
  {
    value: 'GST_EXCLUDED',
    label: 'GST excluded',
    hint: 'No GST is charged. Totals stay as entered.',
  },
];

export function inferInvoiceType(raw = {}) {
  const explicit = String(
    raw?.invoiceType || raw?.services?.invoiceType || '',
  )
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');
  if (explicit === 'GST_INCLUDED' || explicit === 'INCLUSIVE') {
    return 'GST_INCLUDED';
  }
  if (
    explicit === 'GST_EXCLUDED' ||
    explicit === 'GST_EXCLUSIVE' ||
    explicit === 'NO_GST' ||
    explicit === 'NO_TAX'
  ) {
    return 'GST_EXCLUDED';
  }
  if (explicit === 'STANDARD') return 'STANDARD';

  const taxMode = String(
    raw?.workflow?.taxMode || raw?.taxMode || raw?.services?.taxMode || '',
  ).toUpperCase();
  if (taxMode === 'INCLUSIVE') return 'GST_INCLUDED';
  if (taxMode === 'NO_TAX') return 'GST_EXCLUDED';

  if (raw?.gstIncluded ?? raw?.services?.gstIncluded) return 'GST_INCLUDED';
  return 'STANDARD';
}

export function invoiceTypeLabel(type) {
  const key = String(type || 'STANDARD').toUpperCase();
  const opt = INVOICE_TYPE_OPTIONS.find((o) => o.value === key);
  return opt?.label || 'Standard invoice';
}

export function calcInvoiceTotals(subtotal, invoiceType) {
  const sub = Number(subtotal) || 0;
  const type = String(invoiceType || 'STANDARD').toUpperCase();
  if (type === 'GST_INCLUDED') {
    const gst = sub / 11;
    return { subtotalExGst: sub - gst, gst, grandTotal: sub };
  }
  if (type === 'GST_EXCLUDED') {
    return { subtotalExGst: sub, gst: 0, grandTotal: sub };
  }
  const gst = sub * 0.1;
  return { subtotalExGst: sub, gst, grandTotal: sub + gst };
}

export function gstLineLabel(invoiceType) {
  const type = String(invoiceType || 'STANDARD').toUpperCase();
  if (type === 'GST_INCLUDED') return 'GST included (10%)';
  if (type === 'GST_EXCLUDED') return 'GST excluded';
  return 'GST (10%)';
}

export function grandTotalLabel(invoiceType) {
  const type = String(invoiceType || 'STANDARD').toUpperCase();
  if (type === 'GST_INCLUDED') return 'GST included';
  if (type === 'GST_EXCLUDED') return 'GST excluded';
  return 'inc. GST';
}
